import { TIME_DIFF_GENERATOR, createTimeDiff } from './time-diff';
import { TAInput, parseInputValue, validateTAInputType } from './time-past';
import { Injectable, inject } from '@angular/core';
import { Observable, distinctUntilChanged, filter, interval, map, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimePastService {
  readonly #timeDiffGenerator = inject(TIME_DIFF_GENERATOR);
  readonly #currentPeriod = 1;
  readonly #ticker = interval(1000);
  readonly #intervalTimer = this.#ticker.pipe(
    filter((tick) => tick % this.#currentPeriod === 0),
    map((tick) => tick / this.#currentPeriod)
  );

  timePast(value: TAInput): Observable<string | undefined> {
    if (validateTAInputType(value) === false) {
      return of(undefined);
    }

    return this.#intervalTimer.pipe(
      map(() => this.#timeDiffGenerator(createTimeDiff(parseInputValue(value)))),
      distinctUntilChanged()
    );
  }
}
